import { loadImage } from './platform.js';
export const UI_COLORS = { panel: 'rgba(6,49,53,.84)', text: '#fff0cb', muted: '#c4d3bc', gold: '#e2bf79' };

export function pill(ctx, x, y, w, h, radius = h / 2) {
  ctx.beginPath(); ctx.moveTo(x + radius, y); ctx.arcTo(x + w, y, x + w, y + h, radius);
  ctx.arcTo(x + w, y + h, x, y + h, radius); ctx.arcTo(x, y + h, x, y, radius);
  ctx.arcTo(x, y, x + w, y, radius); ctx.closePath();
}

const iconImages = new Map();
export async function loadUiArt() {
  await Promise.all(['activity','voyage','farm','inventory','kitchen','trees','storm','logistics','orders','interact','sun','moon','house'].map(async id => {
    iconImages.set(id, await loadImage(`assets/ui-icons/${id}.png`));
  }));
}
export function drawWeatherIcon(ctx, x, y, size, night) {
  drawNavIcon(ctx, night ? 'moon' : 'sun', x, y, size);
}

export function formatStatusCount(value) {
  const count = Math.max(0, Math.floor(Number(value) || 0));
  if (!Number.isFinite(count)) return '0';
  const unit = [[1e12, '万亿'], [1e8, '亿'], [1e4, '万']].find(([size]) => count >= size);
  return unit ? `${Number((count / unit[0]).toFixed(1))}${unit[1]}` : String(count);
}

function fitStatusText(ctx, text, width) {
  if (ctx.measureText(text).width <= width) return text;
  let shortened = text;
  while (shortened && ctx.measureText(`${shortened}…`).width > width) shortened = shortened.slice(0, -1);
  return `${shortened}…`;
}

// width/height are CSS dimensions; the caller applies its backing-store scale.
export function drawIslandStatus(ctx, { day, clock, gold, tide, narrow, hour,
  width = ctx.canvas.width, height = ctx.canvas.height }) {
  ctx.clearRect(0, 0, width, height);
  ctx.fillStyle = UI_COLORS.panel; ctx.strokeStyle = UI_COLORS.gold; ctx.lineWidth = 1;
  pill(ctx, 1, 1, width - 2, height - 2, Math.min(18, height / 2)); ctx.fill(); ctx.stroke();
  drawWeatherIcon(ctx, 23, height / 2, 27, hour < 6 || hour >= 18);
  ctx.fillStyle = UI_COLORS.text; ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
  const textX = 43, textWidth = Math.max(1, width - textX - 10);
  const dayTime = `第${formatStatusCount(day)}天  ${clock}`;
  const money = `金币 ${formatStatusCount(gold)}`;
  ctx.font = '600 14px sans-serif';
  const singleLine = `${dayTime} · ${money}`;
  if (!narrow && ctx.measureText(singleLine).width <= textWidth) {
    ctx.fillText(singleLine, textX, height / 2);
  } else {
    ctx.font = '600 13px sans-serif';
    const clockPart = `  ${clock}`;
    const dayPart = fitStatusText(ctx, `第${formatStatusCount(day)}天`, textWidth - ctx.measureText(clockPart).width);
    ctx.fillText(`${dayPart}${clockPart}`, textX, height / 2 - 9);
    ctx.font = '500 13px sans-serif';
    ctx.fillText(fitStatusText(ctx, `${money} · ${tide}`, textWidth), textX, height / 2 + 9);
  }
}

export function drawNavIcon(ctx, id, x, y, size) {
  const image = iconImages.get(id);
  if (image) ctx.drawImage(image, x - size / 2, y - size / 2, size, size);
}

export function drawIslandNavigation(ctx, tabs, { cols, rows, active, pixelRatio = 1 }) {
  const width = ctx.canvas.width, height = ctx.canvas.height;
  const scale = Math.max(1, pixelRatio);
  ctx.clearRect(0, 0, width, height); ctx.fillStyle = UI_COLORS.panel; ctx.strokeStyle = UI_COLORS.gold; ctx.lineWidth = scale;
  pill(ctx, 2 * scale, 2 * scale, width - 4 * scale, height - 4 * scale, 12 * scale); ctx.fill(); ctx.stroke();
  const cellWidth = (width - 16 * scale) / cols, cellHeight = (height - 8 * scale) / rows;
  const buttons = tabs.map(([id, title], index) => {
    const x = 8 * scale + index % cols * cellWidth, y = 4 * scale + Math.floor(index / cols) * cellHeight;
    if (id === active) { ctx.fillStyle = 'rgba(221,190,116,.14)'; pill(ctx, x+2*scale,y+2*scale,cellWidth-4*scale,cellHeight-4*scale,8*scale); ctx.fill(); }
    const iconSize = Math.min(25 * scale, cellHeight * .48, cellWidth * .38);
    drawNavIcon(ctx, id, x + cellWidth/2, y + cellHeight * .32, iconSize);
    ctx.font = `500 ${12 * scale}px sans-serif`;
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillStyle = UI_COLORS.text;
    ctx.fillText(fitStatusText(ctx, title, cellWidth - 8 * scale), x + cellWidth/2, y + cellHeight * .79);
    if (index % cols !== cols-1 && index < tabs.length-1) { ctx.strokeStyle = 'rgba(226,191,121,.18)'; ctx.beginPath();
      ctx.moveTo(x+cellWidth,y+8*scale); ctx.lineTo(x+cellWidth,y+cellHeight-8*scale); ctx.stroke(); }
    return { id: `tab-${id}`, x, y, width: cellWidth, height: cellHeight };
  });
  return buttons;
}
